import { NextResponse } from "next/server";
import axios from "axios";

export async function POST(req) {
  try {    
    const { accessToken } = await req.json();    

    const response = await axios.get("https://graph.facebook.com/v21.0/me",{
        params: {
          fields: "accounts{fan_count,features,followers_count,general_info,link,location,name,phone,access_token,bio,description,likes}",
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return NextResponse.json({ data: response.data });
  } catch (error) {
    console.error("Error during getting facebook data:", error.response ? error.response.data : error.message);
    return NextResponse.json(
      { error: "Facebook data retrieve failed", details: error.response ? error.response.data : error.message },
      { status: 500 }
    );
  }
}
